import { createAction } from "@reduxjs/toolkit";
export const add_supplement = createAction("supplement/add");
export const get_supplements = createAction("supplement/get");
export const setAsset = createAction('SET_ASSET');
export const setConstantTypes = createAction('SET_CONSTANT_TYPES');
export const setLessee = createAction('SET_LESSEE');
export const setOwner = createAction('SET_OWNER');
export const setRole = createAction("SET_ROLE")
export const setLessor = createAction("SET_LESSOR")
export const setEvent = createAction("SET_EVENT")
export const setLeaseDurationType = createAction("SET_LEASE_DURATION_TYPE")
export const setBanks = createAction("SET_BANKS")
export const setCurrencies = createAction("SET_CURRENCIES")
export const setPermission = createAction("SET_PERMISSION")
export const setLoading = createAction("SET_LOADING");
export const setLeaseBasicDetails = createAction("SET_LEASE_BASIC_DETAILS")
export const setAssembly=createAction("SET_ASSEMBLY") 
export const setRevisonHistory=createAction("SET_REVISONHISTORY") 
export const setFileUploadDetails=createAction("SET_FILEUPLOAD") 
export const setStorage=createAction("SER_STORAGE")
export const setUploadFiles =createAction("SET_UPLOAD_FILES")
export const setSummryList=createAction("SET_SUMMRYlIST")
export const setUserLessorList=createAction("SET_USER_LESSOR_LIST")
